import type { WritableConfiguratorStoreState } from '@ui/features/configurator/types';

import type { ConfiguratorAction } from './types';

export type SetIsHydratingAction = ConfiguratorAction<
  'setIsHydrating',
  { isHydrating: boolean }
>;

export const setIsHydrating = (isHydrating: boolean): SetIsHydratingAction => ({
  type: 'setIsHydrating',
  payload: {
    isHydrating,
  },
});

export function setIsHydratingAction(
  state: WritableConfiguratorStoreState,
  isHydrating: boolean,
) {
  state.isHydrating = isHydrating;
}
